import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const couponlineRouter: Array<RouteRecordRaw> = [
    {
        path: '/couponline',
        name: '电子券直充',
        component: Layout,
        redirect: '/couponline/product-list',
        meta: { title: '电子券直充', icon: 'icon-card', alwaysShow: true },
        children: [
            {
                path: 'product-list',
                name: '电子券直充商品列表',
                component: () => import('@/views/couponline/ProductList.vue'),
                meta: { title: '商品列表', keepAlive: true, depth: 30 }
            },
            {
                path: 'product-edit',
                name: '电子券直充商品编辑',
                component: () => import('@/views/couponline/ProductEdit.vue'),
                meta: { title: '商品编辑' }
            },
            {
                path: 'product-list-channel',
                name: '默认渠道配置',
                component: () => import('@/views/couponline/ProductList.vue'),
                meta: { title: '默认渠道配置', keepAlive: true, depth: 30 }
            },
            {
                path: 'order-list',
                name: '电子券直充订单列表',
                component: () => import('@/views/couponline/OrderList.vue'),
                meta: { title: '订单列表' }
            },
        ]
    }
]

export default couponlineRouter